import src from "IMAGE";
export default { src, width: 328, height: 62, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADoidYUXEyFZExMTXRUVFWcUFBRlEhISWhcXF3YSEhJYABsOLj8MCw42Dw8PSA4ODkgRERFXERERVBEREVUUFBRkXZYJwn8GMe8AAAAASUVORK5CYII="};
